<div fxLayout="column" fxLayoutAlign="space-evenly stretch" style="margin:5px">


  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>
      <kendo-floatinglabel text="Item #">
        <input [disabled]="true" [(ngModel)]="itemNum" name="itemNum" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
    <div>
      <kendo-floatinglabel text="Chain">
        <input [disabled]="true" [(ngModel)]="chain" name="_chain" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
  </div>


  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>
      <kendo-floatinglabel text="Generic#">
        <input [disabled]="true" [(ngModel)]="generic" name="_generic" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
    <div>
      <kendo-floatinglabel text="DC">
        <input [disabled]="true" [(ngModel)]="dc" name="_dc" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
  </div>


  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>
      <kendo-floatinglabel class="itemDesc" floatingLabel="Item Desc">
        <input [disabled]="true" [(ngModel)]="itemDesc" name="_itemDesc" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
  </div>


  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>
      <kendo-floatinglabel text="Purchase UOM">
        <input [disabled]="true" [(ngModel)]="purchaseUOM" name="_purchaseUOM" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
    <div>
      <kendo-floatinglabel text="Pack Size">
        <input [disabled]="true" [(ngModel)]="packSize" name="_packSize" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
    <div>
      <kendo-floatinglabel text="Pack UOM">
        <input [disabled]="true" [(ngModel)]="packUom" name="_packUom" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
  </div>


  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>
      <kendo-floatinglabel text="Max Quantity">
        <input [disabled]="true" [(ngModel)]="maxQuantity" name="_maxQuantity" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
    <div>
      <input type="checkbox" [disabled]="true" kendoCheckBox name="_criticalItem"/>
      <label class="k-label">Critical Item </label>
    </div>
    <div>
      <input type="checkbox" [disabled]="true" kendoCheckBox name="_active"/>
      <label class="k-label">Active</label>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>
      <input type="checkbox" [disabled]="true" kendoCheckBox name="_restriction"/>
      <label class="k-label">Restriction</label>
    </div>
    <div>
      <input type="checkbox" [disabled]="true" kendoCheckBox name="_enforce"/>
      <label class="k-label">Enforce</label>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>
      <kendo-floatinglabel text="Bin Bay#">
        <input [disabled]="true" [(ngModel)]="binBay" name="_binBay" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
    <div>
      <kendo-floatinglabel text="Cube Size">
        <input [disabled]="true" [(ngModel)]="cubeSize" name="_cubeSize" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>
      <kendo-floatinglabel text="XREF Factor">
        <input [disabled]="true" [(ngModel)]="xrefFactor" name="_xrefFactor" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
    <div>
      <kendo-floatinglabel text="Item Price">
        <input [disabled]="true" [(ngModel)]="itemPrice" name="_itemPrice" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
  </div>


  <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign=" stretch" style="margin-bottom: 4px">
    <div>
      <kendo-floatinglabel text="GL Code#">
        <input [disabled]="true" [(ngModel)]="glCode" name="_glCode" kendoTextBox/>
      </kendo-floatinglabel>
    </div>
    <div>
      <input type="checkbox" [disabled]="true" kendoCheckBox name="_catchWeight"/>
      <label class="k-label">Catch Weight</label>
    </div>
  </div>


</div>
